import { loadPublishTermsFail, loadPublishTermsStart, loadPublishTermsSuccess } from '../../../actions/publishTerms';
import { generateOnloadErrorAction } from '../../../actions/webview/onloadErrors';
import { selectIsPublishToHiddenBase } from '../../../selectors/publishAvailable';
import { selectPublishTermsRequestParameters } from '../../../selectors/publishTerms';
import { getPublishTerms, TLoadPublishTermsResult } from '../../../services/getPublishTerms';
import { IAppState } from '../../../../AppModulesWrapper';
import { TThunkAction } from '../../../../common/types/thunk';

interface IParams {
  isServicesReload: boolean;
}

export function loadPublishTerms(
  { isServicesReload }: IParams = { isServicesReload: false },
): TThunkAction<Promise<TLoadPublishTermsResult | null>> {
  return async function (dispatch, getState, { httpApi, logger, webview }) {
    try {
      const state: IAppState = getState();

      const isPublishToHiddenBase = selectIsPublishToHiddenBase(state);

      if (isPublishToHiddenBase) {
        return null;
      }

      dispatch(loadPublishTermsStart({ isReloading: isServicesReload }));

      const parameters = selectPublishTermsRequestParameters(state);

      logger.debug('publishTerms parameters', { parameters: JSON.stringify(parameters) });

      // у объявления должна быть категория
      if (!parameters.category) {
        dispatch(loadPublishTermsFail());

        webview.sendAction(generateOnloadErrorAction('no-category-publish-terms-load-fail'));

        return null;
      }

      const response: TLoadPublishTermsResult = await getPublishTerms({ httpApi, parameters, logger });

      if (response.success) {
        dispatch(loadPublishTermsSuccess(response.payload));
      } else {
        logger.debug('getPublishTerms error response', { response: JSON.stringify(response) });
        dispatch(loadPublishTermsFail(response.payload));
        webview.sendAction(generateOnloadErrorAction('publish-terms-load-fail'));
      }

      return response;
    } catch (e) {
      dispatch(loadPublishTermsFail());
      webview.sendAction(generateOnloadErrorAction('publish-terms-load-fail'));

      return null;
    }
  };
}
